<template>
  <div class="text-xs-center">
    <v-dialog fullscreen v-model="dialog">
      <v-card>
        <v-toolbar color="primary" dark tabs>
          <v-toolbar-title>{{titleAction}}</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn @click="cancel()" dark icon>
            <v-icon>close</v-icon>
          </v-btn>

          <v-tabs color="primary" slider-color="blue" slot="extension" v-model="tabActive" centered>
            <v-tab>{{$tc('entity')}}</v-tab>
            <v-tab :disabled="action==='create'">{{$tc('team', 2)}}</v-tab>
            <v-tab>{{$t('participants')}}</v-tab>
          </v-tabs>
        </v-toolbar>
        <v-card-text>
          <v-tabs-items v-model="tabActive">
            <v-tab-item ripple>
              <tab-informacion
                @close="close()"
                :edit-external="edit"
                :status="dialog"
                :action="action"
              />
            </v-tab-item>

            <v-tab-item ripple>
              <tab-equipos :edit-external="edit"/>
            </v-tab-item>
            <v-tab-item ripple>
              <tab-participants :participants="edit"/>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" color="primary" small>{{$t('cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import tabEquipos from './tabTeams'
import tabInformacion from './tabInformation'
import tabParticipants from './tabParticipants'

export default {
  name: 'formManager',
  components: {
    tabInformacion,
    tabEquipos,
    tabParticipants
  },
  props: {
    modal: {
      type: Boolean,
      required: true
    },
    edit: {
      type: Boolean,
      required: false,
      default: true
    },
    action: {
      type: String,
      required: false,
      default: 'view'
    }
  },
  data () {
    return {
      tabActive: null
    }
  },
  computed: {
    dialog: {
      get () {
        return this.modal
      },
      set (value) {
        if (!value) {
          this.tabActive = 0
          this.$emit('close')
        }
      }
    },
    titleAction () {
      switch (this.action) {
        case 'create':
          return this.$t('newAModel', { field: this.$tc('entity') })
        case 'remove':
          return this.$t('deleteModel', { field: this.$tc('entity') })
        case 'update':
          return this.$t('updateModel', { field: this.$tc('entity') })
      }
    }
  },
  methods: {
    cancel () {
      this.dialog = false
    },
    close () {
      this.dialog = false
    }
  }
}
</script>
